// The Order Invite order window, shared by the invite materialiser
// (sms-jobs/actions/invite_rotation.ts), the backlog sweep
// (sms-actions/actions/invite_backlog.ts), the forecast fallback
// (src/utils/inviteForecast.ts) and the Invitation tab copy. Twin of the
// window arithmetic in the get_invite_forecast() migration — keep both in sync.
//
// Captain's rule (2026-09-15): the daily batch invites everyone who ordered
// on the previous store-local CALENDAR DAY. Not a rolling N-hour window ending
// at the send hour — "it does not have to be exact". So a batch that runs on
// Tuesday (at whatever send hour) covers Monday 00:00 → Tuesday 00:00 local;
// Tuesday's orders go out in Wednesday's batch.

import { addDaysToDateString, localDate, localMidnightUTC } from "./quietHours.ts";

/** A half-open order window [start, end), as ISO instants. */
export interface OrderWindow {
  start: string;
  end: string;
}

/** The order window for a batch that runs at `runAt`: the whole store-local
 *  calendar day before the run's date. */
export function orderWindowForRun(runAt: Date, timezone: string): OrderWindow {
  const runDay = localDate(runAt, timezone);
  const previousDay = addDaysToDateString(runDay, -1);
  return {
    start: localMidnightUTC(previousDay, timezone).toISOString(),
    end: localMidnightUTC(runDay, timezone).toISOString(),
  };
}

/** Whether `lastOrderAt` falls inside `window` ([start, end)). */
export function isInOrderWindow(lastOrderAt: string | null, window: OrderWindow): boolean {
  if (!lastOrderAt) return false;
  const t = new Date(lastOrderAt).getTime();
  return t >= new Date(window.start).getTime() && t < new Date(window.end).getTime();
}
